import { useAuth } from './useAuth';

export interface EmailVerificationCheck {
  isEmailVerified: boolean;
  requiresVerification: boolean;
  verificationMessage: string;
}

export function useEmailVerification(): EmailVerificationCheck {
  const { user, isAuthenticated } = useAuth();

  const isEmailVerified = user?.isVerified === true;
  const requiresVerification = isAuthenticated && !isEmailVerified;
  const verificationMessage = 'Για να εκτελέσετε αυτή την ενέργεια πρέπει πρώτα να επιβεβαιώσετε το email σας.';

  return {
    isEmailVerified,
    requiresVerification,
    verificationMessage
  };
}

export function useEmailVerificationGuard() {
  const { isEmailVerified, requiresVerification, verificationMessage } = useEmailVerification();

  const checkEmailVerification = (actionName?: string): boolean => {
    if (requiresVerification) {
      return false;
    }
    return true;
  };

  const getVerificationMessage = (actionName?: string): string => {
    return actionName 
      ? `Για να ${actionName} πρέπει πρώτα να επιβεβαιώσετε το email σας.`
      : verificationMessage;
  };

  return {
    isEmailVerified,
    requiresVerification,
    checkEmailVerification,
    getVerificationMessage
  };
}